<template>
  <template v-if="requests && requests.length > 0">
    <template v-for="request in requests" :key="request">
      <div class="columns" v-if="request['ДокументОснованиеПредставление'] !== null" style="margin-bottom: 10px; width: 98vw">
        <div class="column is-10">
          <div class="card" :class="{'has-background-warning-light' : request['Статус'] === '0. Зарегистрировано'}">
            <div class="card-content">
              <div class="media">
                <div class="media-left">
                  <button v-on:click="download_doc(request['ДокументОснование'])" class="button has-addons is-light my-link is-info" style="margin-bottom: 10px; width: 100%">
                  <span class="icon">
                    <font-awesome-icon icon="fa-solid fa-file-arrow-down" />
                  </span>
                  </button>
                </div>
                <div class="media-content">
                  <p class="title is-4">{{ request['ДокументОснованиеПредставление'] }}</p>
                  <p class="subtitle is-6">{{ request['Статус'] }}</p>
                </div>
              </div>

              <div class="content">
                <p><strong>Физ.объект: </strong>{{ request['ФизОбъект'] }}</p>
                <p><strong>Описание обращения: </strong>{{ request['ДокументОснованиеОписание'] }}</p>
                <p><strong>Пояснение: </strong>{{ request['Пояснения'] }}</p>
                <br />
                <time v-if="request['ОжидаемаяДата']"><strong>Ожидаемая дата: </strong>{{ moment(request['ОжидаемаяДата']).format('DD.MM.YYYY')  }}</time>
                <time v-else>Дата не указана</time>
                <table v-if="request['ДокументОснование1'].length > 0">
                  <thead>
                  <tr>
                    <th>Наименование работ</th>
                    <th>Кол-во</th>
                    <th>Цена</th>
                    <th>Сумма</th>
                    <th>Ставка НДС</th>
                    <th>Сумма НДС</th>
                    <th>Итого</th>
                  </tr>
                  <tr v-if="request['ДокументОснование1'].length > 1 && calculate(request) > 0">
                    <th colspan="6"></th>
                    <th>{{ calculate(request) }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="doc in request['ДокументОснование1']" :key="doc">
                    <td>{{ doc['ДокументОснованиеНаименованиеРабот'] }}</td>
                    <td>{{ doc['ДокументОснованиеКоличество'] }}</td>
                    <td>{{ doc['ДокументОснованиеЦена'] }}</td>
                    <td>{{ doc['ДокументОснованиеСумма'] }}</td>
                    <td>{{ doc['ДокументОснованиеСтавкаНДС'] }}</td>
                    <td>{{ doc['ДокументОснованиеСуммаНДС'] }}</td>
                    <td style="font-weight: bold">{{ doc['ДокументОснованиеВсего'] }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-2">
          <button :disabled="loading || request['Статус'] === '1. В работе'" v-on:click="doc_make(request['Ссылка'],'work')" class="button has-addons is-light my-link is-info" style="margin-bottom: 10px; width: 100%">
            <span class="icon is-small"><font-awesome-icon icon="fa-regular fa-circle-play" /></span>
            <span class="can-be-splitted">В работе</span>
          </button>
          <button :disabled="loading" v-on:click="doc_make(request['Ссылка'],'success')" class="button has-addons is-light my-link is-success" style="margin-bottom: 10px; width: 100%">
            <span class="icon is-small"><font-awesome-icon icon="fa-solid fa-circle-check" /></span>
            <span class="can-be-splitted">Согласовано / решено</span>
          </button>
          <button :disabled="loading" v-on:click="doc_make(request['Ссылка'],'abort')" class="button has-addons is-light my-link is-danger" style="margin-bottom: 10px; width: 100%">
            <span class="icon is-small"><font-awesome-icon icon="fa-solid fa-circle-xmark" /></span>
            <span class="can-be-splitted">Не согласовано / отказано</span>
          </button>
          <button :disabled="loading || request['Статус'] === '2. Отложено'" v-on:click="doc_make(request['Ссылка'],'long')" class="button has-addons is-light my-link is-warning" style="margin-bottom: 10px; width: 100%">
            <span class="icon is-small"><font-awesome-icon icon="fa-solid fa-arrows-turn-right" /></span>
            <span class="can-be-splitted">Отложено</span>
          </button>

        </div>
      </div>
    </template>
  </template>

  <div class="card" v-else>
    <div class="card-content">
      <p class="title">
        Заявки на согласования не найдены!
      </p>
      <p class="subtitle">{{ 0 }}</p>
    </div>
    <footer class="card-footer">
      <p class="card-footer-item button is-text" v-on:click="getRequests()">
        <span>ОБНОВИТЬ</span>
      </p>
    </footer>
  </div>



</template>

<script>
import {dataURLtoFile} from "@/lib/utils";
import moment from "moment";

export default {
  name: "ProposalTickets",
  computed: {
    requests: {
      get() {
        return this.$store.getters.REQUESTS
      },
      set(v) {
        this.$store.dispatch('REQUESTS', v)
      }
    }
  },
  async beforeMount() {
    await this.getRequests()
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    moment,
    download_doc: async function (id) {
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.DB}/v4_mobilen/GetOrderDocument`
      let raw = JSON.stringify({
        document_guid:  id,
        format: 'pdf'
      })
      let meta = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.$store.getters.TOKEN
        },
        body: raw
      }
      console.log(url)
      fetch(url, meta)
          .then(async response => {
            if (!response.ok) throw `Ошибка загрузки печатных форм по документу`
            return response.json()
          })
          .then(data => {
            if (data) {
              if (data['ДефВедомость'] && data['ДефВедомость']['ДвоичныеДанные']) {
                let doc = dataURLtoFile(`data:application/pdf;base64,${data['ДефВедомость']['ДвоичныеДанные']}`, `дефектная_ведомость.${data['ДефВедомость']['Расширение']}`)
                const a = document.createElement("a")
                a.href = URL.createObjectURL(doc);
                a.download = doc.name
                a.click();
              }
            }
          })
          .catch(async err => {
            console.error(err)
          })
    },
    doc_make: async function (id, action) {
      this.loading = true
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.DB}/ProposalDoc/${id}/${action}`
      let properies = {
        method: 'GET',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.$store.getters.TOKEN
        }
      }
      await fetch(url, properies)
          .then(response => response.text())
          .then(async result => {
            console.log(result)
            await this.getRequests()
          }).catch(err => {
            console.error(err)
          }).finally(() => {
            this.loading = false
          })
    },
    calculate: function (doc) {
      let docs = doc['ДокументОснование1']
      let count = 0

      for (let d of docs) {
        count = count + d['ДокументОснованиеВсего']
      }
      return count.toFixed(2)
    },
    getRequests: async function () {
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.DB}/${this.$config.API_VERSION}/GetRequests`
      let properies = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.$store.getters.TOKEN
        }
      }
      await fetch(url, properies)
          .then(response => response.text())
          .then(async result => {
            this.requests = JSON.parse(result)
          })
    },
  }
}
</script>

<style scoped lang="scss">

</style>
